<template>
  <main-layout>
    <!--  左メニュー 開始  -->
    <div slot="left-side">
      <menubar screenIdParam="M-10-02"></menubar>
    </div>
    <!--  左メニュー 終了 -->

    <div slot="header">
      <head-title class="cancel-width">
        <div slot="title" class="detail-type">
          <img src="@/assets/icon/sp-icon-back-new.svg" class="back-image-type" v-show="searchResult.entranceTitle" @click="back"/>
          <label slot="title"> {{ searchResult.entranceTitle }}</label>
        </div>
      </head-title>
    </div>

    <div slot="body" style="padding-top:20px">
        <div class="detail-type" >
          <div class="rezDetail-type">
            {{$t('label.entrance.detail.rezDetail')}}
          </div>

          <div :class="checkCode(code)">
            {{ code | checkTypeCode}}
          </div>
        </div>

        <div class="detail-type font-size-16" style="margin-bottom:40px">
          <div class="dateTime-type">
            {{$t('label.entrance.detail.date')}}
          </div>
          <span v-if="!searchResult.allDayFlag">
            {{searchResult.date | formatDate}}
          </span>
          <span v-if="!searchResult.allDayFlag" class="m-left-1">
            {{searchResult.startTime}} - {{searchResult.endTime}}
          </span>
          <span v-if="searchResult.allDayFlag">
            {{ $t("label.entrance.search.allDay") }}
          </span>
        </div>

        <div class="detail-type" style="margin-bottom:40px">
          <div class="dateTime-type">
            {{$t('label.entrance.detail.master')}}
          </div>

          <div class="font-size-16">
            <div>
              {{ searchResult.urgeFullName }}
            </div>
            <div style="font-size:12px">
              {{ searchResult.urgeCompanyName }}
            </div>
            <div style="font-size:12px">
              {{ searchResult.urgeEmail }}
            </div>
            <div style="font-size:12px">
              {{ searchResult.urgeTelNo }}
            </div>
          </div>
        </div>

        <div v-auth="{ auth: '050302'}" class="detail-type" style="margin-bottom:40px">
          <div class="dateTime-type">
            {{ $t("label.entrance.search.receptionComment") }}
          </div>

          <div class="reception-comment-div font-size-16">
            <el-input
              class="textarea-reception-style"
              style="margin-bottom:16px"
              :autosize="{ minRows: 1, maxRows: 5}"
              :placeholder="$t('label.entrance.search.placeholder')"
              v-model="searchResult.recepComment"
              type="textarea">
            </el-input>
            <div class="save-button-div">
              <el-button class="save-button" :disabled="searchResult.recepComment == null || oldRecepComment == searchResult.recepComment" @click="updateComment" v-auth="{ auth: '050302'}" style="margin-right: 16px;">
                {{ $t("label.entrance.search.save") }}
              </el-button>
              <img v-if="oldRecepComment != null && oldRecepComment != '' && oldRecepComment != undefined" src="@/assets/icon/iot-edit-icon.svg" alt="" style="margin-right: 8px;">
              <div v-if="oldRecepComment != null && oldRecepComment != '' && oldRecepComment != undefined" style="font-size: 13px;color: #525250;">
                {{ searchResult.recepCommentLastUpdateName?searchResult.recepCommentLastUpdateName:'' }} {{ searchResult.recepCommentLastUpdateDateTime?searchResult.recepCommentLastUpdateDateTime:'' | formatMonthDayTime}}
              </div>
            </div>
          </div>
        </div>

        <div class="entrantsList-type">
          {{$t('label.entrance.detail.entrantsList')}}
        </div>

        <el-table
          class="el-table-type"
          :data="searchResult.participantList"
          :row-class-name="tableRowClass"
          :key="reflush">
          <el-table-column
            prop="fullname"
            class-name="col-5"
            :label="$t('label.entrance.detail.fullName')">
            <template slot-scope="scope">
              <div class="detail-type">
                <div>
                  {{scope.row.fullname}}
                </div>
                <div v-if="scope.row.urgeFlag" class="master-type">
                  <span class="master-word">
                    {{$t('label.entrance.detail.master')}}
                  </span>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            class-name="col-5"
            prop="companyName"
            :label="$t('label.entrance.detail.companyName')"
          />

          <el-table-column
            class-name="col-5"
            prop="email"
            :label="$t('label.entrance.detail.email')"
          />

          <el-table-column
            class-name="col-3"
            :label="$t('label.entrance.detail.entranceSituation')">
            <template slot-scope="scope">
              <div :class="scope.row.colorStyle" >
                <span v-if="scope.row.entranceFlag">
                  {{ scope.row.lastUpdateDateTime | formatLastUpdateDateTime}}
                </span>
                <span>
                  {{ scope.row.entranceFlag | checkEntranceFlage }}
                </span>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            class-name="col-2"
            align="center"
            header-align="center"
            :label="$t('label.entrance.detail.entrances')">
            <template slot-scope="scope">
              <el-switch class="switch-type" v-model="scope.row.entranceFlag" @change="updateData(scope.row ,scope.$index)" v-auth="{ auth: '050302'}">
              </el-switch>
            </template>
          </el-table-column>
        </el-table>

        <el-dialog-prompt
          :centerDialogVisibleParam.sync="centerDialogVisibleIsShow"
          :msgParam="msgParam"
          @on-isPassParam="isPassParam">
        </el-dialog-prompt>

        <loading-dialog :dialogVisible="showLoading" />
    </div>

  </main-layout>
</template>

<script>
import MainLayout from "@/layout/NewDesignLayout"
import headTitle from "@/components/common/head/head"
import Menubar from "@/components/leftmenu/Home";
import SystemManageApi from "@/api/SystemManageApi";
import errorCodeMsg from "@/utils/error-code-msg"
import statusErrorCodeMsg from "@/utils/status-error-msg"
import elDialogPrompt from "@/components/common/el-dialog-prompt-entrance"
import moment from 'moment';
import LoadingDialog from "@/components/common/loading/LoadingDialog";

export default {
  name: "MeetingRoomSearch",
  components: {
    MainLayout: MainLayout,
    Menubar: Menubar,
    headTitle: headTitle,
    elDialogPrompt,
    LoadingDialog
  },
  data() {

    return {
      oldRecepComment: null,
      showLoading: false,
      reflush:true,
      participantListIndex:null,
      lastUpdateDateTime:null,
      entranceFlag:false,
      msgParam: this.$t("message.common.validation.entranceMessage"),
      centerDialogVisibleIsShow: false,
      code:null,
      searchResult: {
        title:null,
        date:null,
        startTime:null,
        endTime:null,
        urgeTelNo: null
      },
      urgeparticipantList:null,
      participantList:[],
      emailList:[],
      submitData: null,
      buttonShwoFlag:true
    }

  },

  watch:{

  },

  filters:{
    checkTypeCode(val) {
      let codeType = '';
      if('01' == val){
        codeType= "施設";
      }else if('03' == val){
        codeType= "指定席";
      }else {
        codeType= "ゲスト入館予約";
      }
      return codeType;
    },

    formatDateTime(val) {
      return moment(val).format("YYYY年M月D日 HH:mm")
    },

    formatDate(val) {
      return moment(val).format("YYYY年M月D日 (dd)")
    },

    formatMonthDayTime(val) {
      return moment(val).format("M月D日 (dd) HH:mm")
    },

    checkEntranceFlage(val) {
      if(val){
        return "入館済み"
      }else {
        return "未入館"
      }
    },

    formatLastUpdateDateTime(val) {
      return moment(val).format("HH:mm")
    },

  },

  created(){
    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/entrance/search",
        title: "label.entrance.search.entranceManage",
      },
      {
        path: "",
        title: "label.entrance.detail.entranceDetail",
      }
    ]
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb)
    let query = this.$getPageInfo("entrance", "entranceDetail", "M-10-02", "query")
    this.code = query.typeCode
    this.rezId = query.rezId
    this.detailRezData()
  },

  methods:{

    updateComment() {
      this.showLoading = true
      let query = {
        rezId : this.searchResult.rezId,
        recepComment: this.searchResult.recepComment
      }
      if(this.code == "01") {
        SystemManageApi.updateMeetingComment(query)
          .catch((error) => {
            errorCodeMsg(error, this)
          })
          .then(({ data }) => {
            if(!statusErrorCodeMsg(data.statusCode, this)) {
              this.showLoading = false
              return;
            }
            this.showLoading = false
            this.detailRezData()
            this.$messageIotSuccess(this.$t("label.entrance.detail.message"))
          })
      }else if(this.code == "03") {
        SystemManageApi.updateFixDeskComment(query)
          .catch((error) => {
            errorCodeMsg(error, this)
          })
          .then(({ data }) => {
            if(!statusErrorCodeMsg(data.statusCode, this)) {
              this.showLoading = false
              return;
            }
            this.showLoading = false
            this.detailRezData()
            this.$messageIotSuccess(this.$t("label.entrance.detail.message"))
          })
      }else if(this.code == "04") {
        SystemManageApi.updateEntranceComment(query)
          .catch((error) => {
            errorCodeMsg(error, this)
          })
          .then(({ data }) => {
            if(!statusErrorCodeMsg(data.statusCode, this)) {
              this.showLoading = false
              return;
            }
            this.showLoading = false
            this.detailRezData()
            this.$messageIotSuccess(this.$t("label.entrance.detail.message"))
          })
      }
    },

    back() {
      this.$router.push({
        name : "entrance-manage-search",
      })
    },

    tableRowClass(row) {
      if(row.row.colorStyle == "word-red") {
        return 'red-row'
      }else {
        return ''
      }
    },

    changeSwitch() {
      this.searchResult.participantList[this.participantListIndex].entranceFlag = !this.searchResult.participantList[this.participantListIndex].entranceFlag
      if(this.searchResult.participantList[this.participantListIndex].entranceFlag) {
        this.searchResult.participantList[this.participantListIndex].lastUpdateDateTime = new Date()
        this.searchResult.participantList[this.participantListIndex].colorStyle = "word-red"
      }else {
        this.searchResult.participantList[this.participantListIndex].colorStyle = "word-black"
      }
      this.$forceUpdate();
    },

    updateData(row , index) {
      row.entranceFlag = !row.entranceFlag
      this.participantListIndex = index
      this.emailList = []
      this.emailList.push(row.email)
      this.submitData={
        rez_id :  this.searchResult.rezId,
        entranceFlag : !row.entranceFlag,
        emailList : this.emailList
      }
      if(!row.entranceFlag) {
        this.msgParam = this.$t("label.entrance.search.entranceTrue")
      }else {
        this.msgParam = this.$t("label.entrance.search.entranceFlase")
      }
      if(row.entranceFlag) {
        this.centerDialogVisibleIsShow = true
      }else {
        this.updateEntrance()
      }
    },

    checkCode(code) {
      let colorStyle = null
      switch(code) {
        case "01" :
          colorStyle = "meetingRoomstyle"
          break;
        case "03" :
          colorStyle = "reservationstyle"
          break;
        case "04" :
          colorStyle = "workspacestyle"
          break;
      }
      return colorStyle
    },

    detailRezData() {
      this.showLoading = true;
      this.entranceFlag = false
      this.searchResult = []
      this.participantList = []
      this.emailList = []
      this.lastUpdateDateTime = null
      if(this.code == "01") {
        SystemManageApi.detailMeetingRezEntrance(this.rezId)
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({ data }) => {
          if(!statusErrorCodeMsg(data.statusCode, this)) {
            this.showLoading = false;
            return;
          }
          this.searchResult = data.body
          this.oldRecepComment = data.body.recepComment
          this.entranceTitle()
          if(this.searchResult.participantList != null && this.searchResult.participantList.length > 0) {
            this.changeSearchResult()
          }else {
            this.buttonShwoFlag = false
          }
        }).finally(() => {
          this.showLoading = false;
        });
      }else if(this.code == "03") {
        SystemManageApi.detailFixDeskRezEntrance(this.rezId)
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({ data }) => {
          if(!statusErrorCodeMsg(data.statusCode, this)) {
            this.showLoading = false;
            return;
          }
          this.searchResult = data.body
          this.oldRecepComment = data.body.recepComment
          this.entranceTitle()
          if(this.searchResult.participantList != null && this.searchResult.participantList.length > 0) {
            this.changeSearchResult()
          }else {
            this.buttonShwoFlag = false
          }
        }).finally(() => {
          this.showLoading = false;
        });
      }else if(this.code == "04") {
        SystemManageApi.detailEntranceRez(this.rezId)
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({ data }) => {
          if(!statusErrorCodeMsg(data.statusCode, this)) {
            this.showLoading = false;
            return;
          }
          this.searchResult = data.body
          this.oldRecepComment = data.body.recepComment
          this.entranceTitle()
          if(this.searchResult.participantList != null && this.searchResult.participantList.length > 0) {
            this.changeSearchResult()
          }else {
            this.buttonShwoFlag = false
          }
        }).finally(() => {
          this.showLoading = false;
        });
      }

    },

    changeSearchResult() {
      this.urgeparticipantList = null
      this.searchResult.startTime = this.searchResult.startTime.substring(0,5)
      this.searchResult.endTime = this.searchResult.endTime.substring(0,5)
      if(this.code == "02") {
        if (this.searchResult.participantList.length !== 0) {
          this.searchResult.participantList[0].urgeFlag = true
        }
        // this.searchResult.urgeFullName = this.searchResult.participantList[0].fullname
        // this.searchResult.urgeCompanyName = this.searchResult.participantList[0].companyName
        // this.searchResult.urgeEmail = this.searchResult.participantList[0].email
        // this.searchResult.urgeTelNo = this.searchResult.participantList[0].urgeTelNo
      }
      for(let index of this.searchResult.participantList) {
        if(index.entranceFlag) {
          this.entranceFlag = true
          if(this.lastUpdateDateTime == null){
            this.lastUpdateDateTime = index.lastUpdateDateTime
          }else if( new Date(index.lastUpdateDateTime).getTime() > new Date(this.lastUpdateDateTime).getTime()) {
            this.lastUpdateDateTime = index.lastUpdateDateTime
          }
        }
        this.emailList.push(index.email)
        if(index.urgeFlag) {
          this.urgeparticipantList = index
        }else {
          this.participantList.push(index)
        }
      }
      for(let i = 0 ; i < this.searchResult.participantList.length ; i++) {
        this.searchResult.participantList[i].colorStyle = this.checkParticipantType(this.searchResult.participantList[i].lastUpdateDateTime , this.searchResult.participantList[i].entranceFlag)
      }
    },

    checkParticipantType(lastUpdateDateTime , entranceFlag) {
      var time1=moment(new Date(lastUpdateDateTime)).format("YYYY-MM-DD HH:mm");
      var time2=moment(new Date()).format("YYYY-MM-DD HH:mm");
      var begin1=time1.substr(0,10).split("-");
      var end1=time2.substr(0,10).split("-");
      var date1=new Date(begin1[1] + - + begin1[2] + - + begin1[0]);
      var date2=new Date(end1[1] + - + end1[2] + - + end1[0]);
      var m=parseInt(Math.abs(date2-date1)/1000/60);
      var min1=parseInt(time1.substr(11,2))*60+parseInt(time1.substr(14,2));
      var min2=parseInt(time2.substr(11,2))*60+parseInt(time2.substr(14,2));
      var n=min2-min1;
      var minutes=m+n;

      if(minutes <= 2 && minutes >=0 && entranceFlag == true) {
        return "word-red"
      }else {
        return "word-black"
      }
    },

    entranceTitle() {
      switch(this.code) {
        case "01" :
          this.searchResult.entranceTitle = this.searchResult.tenantFlag == "01" ? this.searchResult.urgeCompanyName + " / " + this.searchResult.floorName + " " + this.searchResult.placeName : this.searchResult.floorName + " " + this.searchResult.placeName
          break;
        case "02" :
          this.searchResult.entranceTitle = this.searchResult.floorName + " " + this.searchResult.placeName
          break;
        case "03" :
          this.searchResult.entranceTitle = this.searchResult.tenantFlag == "01" ? this.searchResult.urgeCompanyName + " / " + this.searchResult.floorName + " " + this.searchResult.placeName : this.searchResult.floorName + " " + this.searchResult.placeName
          break;
        case "04" :
          this.searchResult.entranceTitle = this.searchResult.urgeCompanyName + " / " + this.searchResult.floorName
          break;
      }
    },

    updateEntrance() {
      this.showLoading = true
      if(this.code == "01") {
          SystemManageApi.updateMeetingRezEntrance(this.submitData)
            .catch((error) => {
              errorCodeMsg(error, this)
            })
            .then(({ data }) => {
              if(!statusErrorCodeMsg(data.statusCode, this)) {
                this.showLoading = false;
                return;
              }
              this.changeSwitch()
              this.showLoading = false
            })
        }else if(this.code == "03") {
          SystemManageApi.updateFixDeskRezEntrance(this.submitData)
            .catch((error) => {
              errorCodeMsg(error, this)
            })
            .then(({ data }) => {
              if(!statusErrorCodeMsg(data.statusCode, this)) {
                this.showLoading = false;
                return;
              }
              this.changeSwitch()
              this.showLoading = false
            })
        }else if(this.code == "04") {
          SystemManageApi.updateEntranceRez(this.submitData)
            .catch((error) => {
              errorCodeMsg(error, this)
            })
            .then(({ data }) => {
              if(!statusErrorCodeMsg(data.statusCode, this)) {
                this.showLoading = false;
                return;
              }
              this.changeSwitch()
              this.showLoading = false
            })
        }
    },

    isPassParam(param){
      if(param) {
        this.updateEntrance()
      }
    },
  }
}

</script>


<style scoped lang="scss">
.title-width {
  width: 150px;
}
.detail-type {
  display: flex;
}
.noEntrance-type{
  background: #fff;
  font-size: 12px;
  text-align: center;
  width: 100px;
  height: 18px;
}
.entrance-type{
  background: #3F9FA8;
  color: #fff;
  font-size: 12px;
  text-align: center;
  width: 100px;
  height: 18px;
}
.lastTime-type {
  font-size: 12px;
  margin-left: 20px;
}
.code-type {
  background-color: #fff;
  width: 100px;
  text-align: center;
  height: 18px;
  font-size: 12px;
  border-radius: 12px ;
}

.meetingRoomstyle {
  text-align: center;
  border-radius: 2px;
  height: 20px;
  line-height: 22px;
  font-size: 12px;
  color: #858582;
  width: 56px;
  background: #DCE5E6;
}

.shareDeskstyle {
  text-align: center;
  border-radius: 2px;
  height: 20px;
  line-height: 22px;
  font-size: 12px;
  color: #858582;
  width: 56px;
  background: #E6DCE5;
}

.reservationstyle {
  text-align: center;
  border-radius: 2px;
  height: 20px;
  line-height: 22px;
  font-size: 12px;
  color: #858582;
  width: 56px;
  background: #F2DCDA;
}
.workspacestyle {
  text-align: center;
  border-radius: 2px;
  height: 20px;
  line-height: 22px;
  font-size: 12px;
  color: #858582;
  width: 100px;
  background: #DCE6DD;
}

.rezDetail-type {
  width: 117px;
  margin-right: 19px;
  font-size: 16px;
  color: #525250;
  margin-bottom: 38px;
}

.dateTime-type {
  width: 117px;
  margin-right: 19px;
  font-size: 16px;
  color: #525250;
}

.font-size-16 {
  font-size: 16px;
  color: #525250;
}

.entrantsList-type {
  font-size: 20px;
  color: #525250;
  margin-bottom: 30px;
}

.word-red {
  color: #E65245;
}

.word-black {
  color: #525250;
}

.back-image-type {
  margin-right: 20px;
  cursor: pointer;
}

.master-type {
  min-width: 52px;
  text-align: center;
  border-radius: 2px;
  margin-left: 8px;
  width: 52px;
  height: 15px;
  background-color: #858582;
  color: #FFFFFF;
}

.master-word {
  font-size: 9px;
  display: flex;
  width: 100%;
  padding-top: 2px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

::v-deep .el-table .cell {
  padding-left: 0px;
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
  opacity: unset !important;
}

.switch-type:hover {
  opacity: 0.6;
}

::v-deep .el-table th.is-center, .el-table td.is-center {
  text-align: center !important;
}

::v-deep .el-table .red-row {
  background: rgb(230,82,69,0.08) !important;
}

.el-table__row {
  background: transparent !important;
}

.reception-comment-div {
  width: 80%;
}

.textarea-reception-style ::v-deep .el-textarea__inner{
  background: #F7F7F2 !important;
  width: 100% !important;
  padding: 16px !important;
  min-height: 48px;
}
.save-button-div {
  display: flex;
  width: 100%;
  text-align: left;
  align-items: center;
}
.save-button-div .is-disabled {
  opacity: 0.5;
}
.save-button {
  padding: 0;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  color: #FFFFFF;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: none;
  margin: 0;
  transition: 0.1s;
  font-size: 13px;
  border-radius: 8px;
  width: 120px;
  height: 32px;
  background-color: #329CA6;
  border: 0;
  box-shadow: -4px -4px 8px #f7f7f2, 4px 4px 8px #d9d9d4;
}

.save-button:hover {
  background-color: #329CA6;
  color: #F2F6FA;
  opacity: 0.8;
}
</style>
